import React from 'react';

export const GoogleArchiveResultIcon = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.444 1H2.556C1.692 1 1 1.7 1 2.56V13.44C1 14.3 1.692 15 2.556 15H13.444C14.3 15 15 14.3 15 13.44V2.56C15 1.7 14.3 1 13.444 1ZM8 12.67L4.889 9.56H11.111L8 12.67ZM11.111 8H4.889V6.44H11.111V8ZM11.111 4.89H4.889V3.33H11.111V4.89Z"
			fill="#73777C"
		/>
	</svg>
);
